import http from '@/requests/http'

class Log {
  static async store (params) {
    return http.post('logs', params)
  }
}

export default Log
